<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Crear Acción de Jugada" />

    <PlayOptionType />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import PlayOptionType from "@/components/Pages/Admin/Plays/Options/view.vue";

export default defineComponent({
  name: "CreatePlayOptionPage",
  components: {
    PageTitle,
    PlayOptionType,
  },
});
</script>
